var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"title":"Dropdown Tree","code-toggler":""}},[_c('v-select-tree',{attrs:{"data":_vm.treeData,"multiple":true},model:{value:(_vm.initSelected),callback:function ($$v) {_vm.initSelected=$$v},expression:"initSelected"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }